<template>
    <div class="vt" :data-required="required">
        <!-- {{instance}} -->
        <div v-if="instance.title || instance.content" class="vt__top v--15">
            <h2 v-if="instance.title" v-html="instance.title" class="vt__title type--h2"></h2>
            <div class="vt__content type--content-links type--content-margins type--content-styles"
                v-html="instance.content"></div>
        </div>
        <div class="vt__members vt__members--audio" ref="members">
            <div v-for="(audio, index) in instance.audio" :key="index" class="vt__member r"
                :data-member-name="audio.title" data-watched="false">
                <div class="vt__member__link r v--5" :data-video="audio.audio">
                    <div v-if="audio.display_title || audio.description" class="vt_member__details r v--5">
                        <p v-if="audio.display_title"><strong>{{ audio.display_title }}</strong></p>
                        <p v-if="audio.description" v-html="audio.description"></p>
                    </div>
                    <AudioPlayer :id="audio.audio" :siloData="siloData" :pauseVideo="pauseVideo"
                        @play="playAudio(audio)" @playingVideo="$emit('playingVideo')"></AudioPlayer>
                </div>
            </div>
        </div>
        <div v-if="instance.hide_button !== true"
            class="vt__footer r r--justify-center r--halign-center v--30 type--align-center">
            <transition name="button">
                <button v-if="!isLast" :disabled="!is_valid" class="ms__next btn btn--solid" @click="$emit('next')">
                    Next
                </button>
                <button v-if="isLast" :disabled="!is_valid" class="btn btn--solid" @click="finish()">
                    Finish
                </button>
            </transition>
        </div>
    </div>
</template>

<script>
import Icon from "@c/Icon.vue";
import AudioPlayer from "@c/AudioPlayer.vue";
export default {
    components: {
        Icon,
        AudioPlayer,
    },
    data() {
        return {
            watched: 0,
            //required: this.instance.required_count ? this.instance.required_count : 0,
            is_valid: false,
            imageSize: "full",
        }
    },
    computed: {
        required() {
            return this.instance.required_count ? parseInt(this.instance.required_count) : 0;
        },
    },
    watch: {
        pauseVideo() {
            if (this.pauseVideo === true) {
                console.log('panel audio pause watch true');
            }
        },
    },
    props: {
        instance: Object,
        siloData: Object,
        active: Boolean,
        pauseVideo: Boolean,
        appState: String,
        isLast: Boolean,
    },
    mounted() {
        this.reset();
        this.validate();
    },
    watch: {
        active() {
            if (this.active === true) {
                this.reset();
            } else {
                this.reset();
            }
        }
    },
    methods: {
        // validate watched count, this only counts for one watch at this time
        validate() {
            if (this.watched >= this.required) {
                this.is_valid = true;
            } else {
                this.is_valud = false;
            }
        },
        playAudio(audio) {
            console.log('we are playing audio');
            console.log(audio.title);

            let parent = this.$refs.members.querySelector(`[data-member-name="${audio.title}"]`);

            if (parent.dataset.watched === "true") return;
            this.postAudioListened();

            this.$emit('playingVideo');

            // Add some style to this specific one
            parent.dataset.watched = "true";

            // Increase watched count
            this.watched++;

            // validate to see if we can move on
            this.validate();
        },
        // ! I DON'T THINK WE'RE USING THIS
        play(member) {

            let name = member.title;

            let parent = this.$refs.members.querySelector(`[data-member-name="${name}"]`);

            // Remove https becuase it screws up subsequent video loads
            // let video_url = member.audio.replace('https:', '');

            // fire the video modal
            // window.videoPlayer.playVideoOnClick('vimeo', member.video);

            // If this has already been watched, we don't need to validate it
            if (parent.dataset.watched === "true") return;

            this.postVideoWatched(member);

            // Add some style to this specific one
            parent.dataset.watched = "true";

            // Increase watched count
            this.watched++;

            // validate to see if we can move on
            this.validate();
        },
        reset() {
            this.watched = 0;
            this.is_valid = false;
            this.$refs.members.querySelectorAll('.vt__member').forEach(member => {
                member.dataset.watched = "false";
                let audio = member.querySelector('audio');
                audio.pause();
                audio.currentTime = 0;
            });
        },
        finish() {
            this.reset();
            this.$emit('close');
        },
        postAudioListened() {
            // Listened to audio: Title (url)
            let message = this.instance.title ? `Listened to audio: ${this.instance.title}` : `Listened to audio`;
            let data = {
                type: 'open',
                message: message,
            };
            window.events.postAction(data);
        },
    }
}
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.vt__members {
    &--audio {
        flex-direction: column;
        gap: rem(40px);

        .vt__member {
            max-width: inherit;

            audio {
                display: block;
                width: 100%;
                height: 60px !important;
            }
        }
    }
}

.vt__member[data-watched="true"] {
    iframe, audio {
        opacity: 0.5 !important;
    }
}

[data-required="0"] {
    .vt__member[data-watched="true"] {
        iframe, audio {
            opacity: 1 !important;
        }
    }
}
</style>